import { USER_STROLLERS_DELETE_CONFIRM } from 'mk/autogenerated/translations/UserStrollersWidget.sagas.7dcfe71b8a67c04a7ba431b2d0139667'
import {
    strollers_api_user_strollers_add_user_stroller_url,
    strollers_api_user_strollers_get_user_stroller_url,
    strollers_api_user_strollers_remove_user_stroller_url,
} from 'mk/urls/functions';
import {
    USER_STROLLER_CONNECTION_CREATE_TRIGGER,
    USER_STROLLER_CONNECTION_REMOVE_TRIGGER,
    USER_STROLLERS_FETCH_TRIGGER,
    UserStrollerConnectionCreateTriggerAction,
    userStrollersConnectionCreateActions,
    userStrollersConnectionRemoveActions,
    userStrollersFetchApi,
    UserStrollersFetchNormalizedResponse,
    UserStrollersFetchTriggerAction,
} from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.actions';
import {
    MinStrollerSchema,
    MinUserReviewSchema,
    StrollerMinEntity,
    UserReviewMinEntity,
} from 'mk2/apps/strollers/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

const logger = getLogger('UserStrollersWidget.sagas');

export interface ApiResponseToConnectUserStroller {
    body: {
        status: string;
        stroller: StrollerMinEntity;
    };
}
function* connectUserStroller({ strollerId, userId, xhr }: UserStrollerConnectionCreateTriggerAction & XHRAction) {
    yield put(userStrollersConnectionCreateActions.request(strollerId, userId));

    try {
        const response: ApiResponseToConnectUserStroller = yield call(() => xhr.post(strollers_api_user_strollers_add_user_stroller_url(), { strollerId, userId }));
        const normalizedResponse = normalize(response.body, {
            stroller: MinStrollerSchema,
        });
        yield put(userStrollersConnectionCreateActions.success(strollerId, userId, normalizedResponse));
    } catch (error) {
        logger.error(error);
        yield put(userStrollersConnectionCreateActions.failure(strollerId, userId, normalizeError(error)));
    }
}

function* disconnectUserStroller({ strollerId, userId, xhr }: UserStrollerConnectionCreateTriggerAction & XHRAction) {
    if (!window.confirm(USER_STROLLERS_DELETE_CONFIRM)) {
        return;
    }
    yield put(userStrollersConnectionRemoveActions.request(strollerId, userId));

    try {
        yield call(() => xhr.post(strollers_api_user_strollers_remove_user_stroller_url(), { strollerId, userId }));
        yield put(userStrollersConnectionRemoveActions.success(strollerId, userId));
    } catch (error) {
        logger.error(error);
        yield put(userStrollersConnectionRemoveActions.failure(strollerId, userId, normalizeError(error)));
    }
}

interface ApiResponseToFetchUserStrollers {
    body: {
        strollers: StrollerMinEntity[];
        reviews: UserReviewMinEntity[];
    };
}

function* fetchUserStrollers({ userId, xhr }: UserStrollersFetchTriggerAction & XHRAction) {
    yield put(userStrollersFetchApi.request(userId));

    try {
        const response: ApiResponseToFetchUserStrollers = yield call(
            () => xhr.get(strollers_api_user_strollers_get_user_stroller_url(), { userId }),
        );

        const normalizedResponse: UserStrollersFetchNormalizedResponse = normalize(response.body, {
            strollers: [MinStrollerSchema],
            reviews: [MinUserReviewSchema],
        });
        yield put(userStrollersFetchApi.success(userId, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(userStrollersFetchApi.failure(userId, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeEvery(USER_STROLLER_CONNECTION_CREATE_TRIGGER, connectUserStroller),
        takeEvery(USER_STROLLER_CONNECTION_REMOVE_TRIGGER, disconnectUserStroller),
        takeLatest(USER_STROLLERS_FETCH_TRIGGER, fetchUserStrollers),
    ]);
}
